<template>
    <div>
        <cus-dialog :visible.sync="visibleSync" class="form-table-h500 dialog" :title="titleContent" width="50%" @confirm="visibleSync = false">
            <div class="margin-none-h align-left">
            <div class="header">
                <div class="surgery" v-if="surgeryInfo">
                    <div>台次:{{surgeryInfo.scheduled_sequence}}</div>
                    <div>手术间:{{surgeryInfo.dic_operating_room}}</div>
                    <div>科室:{{surgeryInfo.dic_section}}</div>
                    <div>术前诊断:{{surgeryInfo.plan_diseases}}</div>
                    <div>拟施手术:{{surgeryInfo.surgeries}}</div>
                    <div>手术医生:{{surgeryInfo.surgeon}}</div>
                    <div>转运开始时间:{{transferFlows && transferFlows[0] &&
                        this.$moment(transferFlows[0].occur_time).format(`YYYY-MM-DD HH:mm:ss`)}}</div>
                    <div>手术计划开始时间:{{surgeryInfo.plan_time && this.$moment(surgeryInfo.plan_time).format(`YYYY-MM-DD
                        HH:mm:ss`)}}</div>
                </div>
            </div>
            <div v-if="transferFlows && transferFlows.length>0" class="scrollContent">
                <div class="content" v-for="(flow, index) in transferFlows" :key="index">
                    <div class="line"></div>
                    <div class="panel">
                        <div v-if="index == 0" class="monthday">{{flow.occur_time && $moment(flow.occur_time).format(`MM-DD`)}}
                        </div>
                        <div class="date" :style="{'top':`${index == 0 ? 22:10}px`}">{{flow.occur_time &&
                            $moment(flow.occur_time).format(`HH:mm`)}}</div>
                        <div class="step">
                            <div class="steprowone">{{flow.modifier}} {{flow.event_name}} <span
                                    v-if="flow.status==2||flow.status==0" style="font-size:14px;">
                                    <span plain type="primary">{{flow.status==2?'已撤回':'撤回操作'}}</span>
                                </span></div>
                            <div>{{flow.modifier}}
                                    <span name="phone" color="#009687" v-if="flow.worker_tel" class="phone">tel:{{flow.worker_tel}}</span>
                                </div>
                            <div class="steprowtwo">转运阶段:{{flow.flow_surgery_stage}}</div>
                            <div class="steprowtwo">转运状态:{{flow.transfer_circulation && flow.transfer_circulation.data_state_name}}
                            </div>
                            <div class="remark">备注:{{flow.remark}}</div>
                            <div v-if="flow.dic_worker_id == currentUser.dic_worker_id" @click="showModifyRemark(flow)">修改</div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="scrollContent" style="text-align: center;font-size: 30px;">
                未开始转运
            </div>
            </div>
        </cus-dialog>
        <cus-dialog title="修改备注" :visible.sync="modifyObj.isShow" width="25%" @confirm="modifyRemark()">
            <div class="margin10 margin-none-h align-left">
                <el-input type="textarea" :rows="3" v-model="modifyObj.remark" placeholder="请录入注意事项"></el-input>
            </div>
        </cus-dialog>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `TranferDetail`,
    props: {
        visible: { type: Boolean },
        surgeryInfo: { type: Object },
        surgeryId: { type: Number }
    },
    data() {
        return {
            modifyObj: {
                isShow: false,
                id: 0,
                remark: ``
            },
            title: `转运详情`,
            transferFlows: null
        }
    },
    created() {
    },
    computed: {
        ...mapGetters([`currentUser`]),
        visibleSync: {
            get: function() {
                if (this.visible) {
                    this.loadOne()
                }
                return this.visible
            },
            set: function(newval) {
                this.$emit(`update:visible`, newval)
            }
        },
        titleContent() {
            let content = this.title
            if (this.surgeryInfo) {
                content = this.title + ` (${this.surgeryInfo.patient_name} ${this.surgeryInfo.sex || `--`}/${this.surgeryInfo.age || `--`}/${this.surgeryInfo.bed_no || `--`}/${this.surgeryInfo.visit_no || `--`})`
            }
            return content
        }
    },
    methods: {
        showModifyRemark(flow) {
            this.modifyObj.isShow = true
            this.modifyObj.remark = flow.remark
            this.modifyObj.id = flow.id
        },
        modifyRemark() {
            let that = this
            let data = {
                id: this.modifyObj.id,
                remark: this.modifyObj.remark
            }
            let req = this.myaxios.put(`/api/TransferEvent/TransferOccurEvent/Put`, data)
            req.then(res => {
                this.modifyObj.isShow = false
                that.loadOne()
            }).catch(e => { console.log(e) })
        },
        loadOne() {
            let req = this.myaxios.get(`/api/TransferEvent/TransferOccurEvent/GetSurgeryTransfer?surgeryId=${this.surgeryId}`)
            req.then(data => {
                this.transferFlows = data
                console.log(this.transferFlows)
            }).catch(e => { console.log(e) })
        }
    },
    watch: {
    }
}
</script>
<style lang="less" scoped>
    .dialog{
        overflow: unset !important;
    }
    .dialog /deep/ .el-dialog {
           height: 750px;
     }
     .dialog /deep/ .el-dialog__body {
        padding:5px 0 0 5px !important;
        overflow: unset !important;
     }
     .dialog /deep/ .el-dialog__body > div {
        overflow: unset !important;
     }
     .dialog /deep/ .el-dialog__footer {
        background: #fafafa;
     }
    .header {
        color: #666666 !important;
        /* background: #04A891 !important; */
        font-size: 14px;
        text-align: left;
        .patient {
            line-height: 23px;
            position: relative;
            display: -webkit-box;
            display: -webkit-flex;
            display: flex;
            -webkit-box-align: center;
            -webkit-align-items: center;
            align-items: center;
            height: 46px;

            .name {
                padding: 0 20px;
                font-size: 17px;
            }
        }
        .surgery {
            border-top: 1px dashed #ffffff;
            display: -webkit-box;
            display: -webkit-flex;
            display: flex;
            -webkit-box-align: center;
            -webkit-align-items: center;
            align-items: center;
            flex-wrap: wrap;
            div {
                width: 46%;
                height: 30px;
                line-height: 30px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                font-weight: 500;
                font-size: 16px;
                padding: 0 16px;
            }
            .time {
                flex-basis: 100% !important;
            }
        }
    }
    .line {
        margin: 0px 24px;
        width: 1px;
        height: 130px;
        background: #EBEBEB;
    }
    .scrollContent {
        height: 500px;
        overflow-y: auto;
        overflow-x: hidden;
    }
    .content {
        display: flex;
        font-size: 20px;
        .panel {
            position: relative;
            width: 100%;
            padding: 0 16px;
            text-align: left;
            .monthday {
                position: absolute;
                left: -40px;
                top: 0px;
                opacity: 1;
                background: #fff;
                font-size: 18px;
            }
            .date {
                position: absolute;
                left: -40px;
                top: 8px;
                opacity: 1;
                background: #fff;
                font-size: 18px;
            }
            .step {
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                justify-content: start;
                font-size: 16px;
                color: rgba(102, 102, 102, 1);
            }
            .steprowone {
                flex-basis: 70%;
                font-weight: 500;
                font-size: 20px;
                color: var(--primary-color, #009688);
                line-height: 36px;
                height: 36px;
                text-align: left;
                font-style: normal;
                overflow-wrap: break-word;
                white-space: nowrap;
                margin-top: 1px;
            }
            .phone {
                background-color: #E0F2EE;
                border-radius: 50%;
                height: 24px;
                width: 24px;
                line-height: 24px;
                text-align: center;
            }
            .steprowtwo {
                flex-basis: 100%;
                margin-top: 5px;
            }
            .remark {
                flex-basis: 90%;
                padding: 5px 10px 10px 0px;
                background-color: rgba(245, 245, 245, 1);
                border-radius: 2px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Transfer/TranferDetail.vue